import { render, staticRenderFns } from "./customers-edit.vue?vue&type=template&id=544d1b08&scoped=true"
import script from "./customers-edit.vue?vue&type=script&lang=js"
export * from "./customers-edit.vue?vue&type=script&lang=js"
import style0 from "./customers-edit.vue?vue&type=style&index=0&id=544d1b08&prod&lang=css"
import style1 from "./customers-edit.vue?vue&type=style&index=1&id=544d1b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544d1b08",
  null
  
)

export default component.exports